import { useState, useEffect } from "react";
import characterImages from "../data/characterImages.ts";

export function useRandomCharacterImage(deps: any[] = []) {
  const [characterImg, setCharacterImg] =
    useState<string>("/assets/aksa-1.png");
  useEffect(() => {
    let isMounted = true;
    async function pickImageAsync() {
      // Simulate async with a small delay
      await new Promise((resolve) => setTimeout(resolve, 100));
      const idx = Math.floor(Math.random() * characterImages.length);
      if (isMounted) setCharacterImg(characterImages[idx]);
    }
    pickImageAsync();
    return () => {
      isMounted = false;
    };
  }, deps);
  return characterImg;
}
